<template>
  <div
    class="play-layout"
    @click="handleAction"
  >
    <button v-if="!isPlaying" class="play-layout__button" :aria-label="$t('HERO_VIDEO_PLAY_BUTTON')">
      <sh-icon v-if="showPlay" class="play-layout__icon" name="playVideo" size="xxlarge"/>
    </button>
    <div v-else class="play-layout__button" :aria-label="$t('HERO_VIDEO_PAUSE_BUTTON')"></div>
</div>
</template>

<script>
import { ShIcon } from '@sohohouse/design-system'

export default {
  name: 'PlayLayout',
  components: {
    ShIcon
  },
  props: {
    isPlaying: {
      type: Boolean,
      require: true
    },
    showPause: {
      type: Boolean,
      require: true
    },
    showPlay: {
      type: Boolean,
      require: true
    }
  },
  methods: {
    handleAction () {
      this.$emit('handleAction')
    }
  }
}
</script>

<style lang="scss" scoped>
.play-layout {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  &__button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    text-align: center;
    border: 0;
    background: transparent;

    &.focus-visible {
      outline: 1px solid $color-white;
    }

    &__icon {
      margin-bottom: $space-070;
    }
  }
}
</style>
